import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
const getMeasuredUsingConfig = (prefix: string) => {
  const initialDryingBalance = wrap(`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.Balance`);
  const dryMassBalance = wrap(`${prefix}.InitialDrying.MeasuredConstantDryMass.Equipment.DryMassBalance`);

  const balanceBinderExtraction = wrap(`${prefix}.Measurements.BalanceBinderExtraction`);
  const balanceBinderSeparation = wrap(`${prefix}.Measurements.BalanceBinderSeparation`);

  return {
    [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.DryMassReadings.DrySoilAndContainerMass`]:
      dryMassBalance,
    [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.ContainerMass`]: initialDryingBalance,
    [`${prefix}.InitialDrying.MeasuredConstantDryMass.DryingTray.WetSoilAndContainerMass`]: initialDryingBalance,

    [`${prefix}.Measurements.FlaskAndStopperMass`]: balanceBinderExtraction,
    [`${prefix}.Measurements.FilterBowlMass`]: balanceBinderExtraction,
    [`${prefix}.Measurements.FilterBowlTestPortionMass`]: balanceBinderExtraction,
    [`${prefix}.Measurements.FlaskStopperSolutionMass`]: balanceBinderExtraction,

    [`${prefix}.Measurements.Trials.ContainerAndLidMass`]: balanceBinderSeparation,
    [`${prefix}.Measurements.Trials.ContainerLidAndLiquidMass`]: balanceBinderSeparation,
    [`${prefix}.Measurements.Trials.ContainerLidAndResidueMass`]: balanceBinderSeparation,
  };
};

export default getMeasuredUsingConfig;
